import * as Sentry from "@sentry/vue";
import { ajax } from 'ajax';
import { get_custom_image_class } from 'custom-image';
import { notify } from 'notify';
import { createPinia } from 'pinia';
import { create_router, router } from 'router';
import { createMainStore } from 'store';
import { createApp } from 'vue';

import { maybe_load_temporal } from './_partials/_utilities';
import App from './app.vue';

( async function() {
	await maybe_load_temporal();

	const app_el = document.getElementById( `app` );
	if( !app_el ) {
		return;
	}

	const params = new URLSearchParams( location.search );

	customElements.define( `custom-image`, get_custom_image_class( window, document ) );

	function init( response ) {
		const pinia = createPinia();

		const app = createApp( App );

		Sentry.init(
			{
				app,
				dsn: response.sentry_dsn,
				// sendDefaultPii: true,
				environment: response.site.environment,
				tunnel: `/tunnel`
			}
		);

		app.directive(
			`zero-if-empty`,
			el => {
				const input = el instanceof HTMLInputElement ? el : el.querySelector( `input` );

				if( !input ) {
					return;
				}

				if( input.type !== `number` ) {
					return;
				}

				if( input.value !== `` ) {
					return;
				}

				input.value = 0;

				const ev = new Event( `input`, {
					bubbles: true
				} );

				input.dispatchEvent( ev );
			}
		);

		// Bare `v-focus` focuses on mount. `v-focus="expr"` focuses only when
		// expr is truthy, so one form can move its initial focus between two
		// elements (members_portal/login.vue: the email field normally, the
		// primary action when the address arrived pre-filled) without a
		// nextTick race against this directive's own requestAnimationFrame.
		app.directive(
			`focus`,
			{
				mounted( el, binding ) {
					if( binding.value === false ) {
						return;
					}

					requestAnimationFrame( () => el.focus?.() );
				}
			}
		);

		app.use( router );

		app.use( pinia );

		app.mount( app_el );
	}

	let has_token = false;
	for( const [key] of params ) {
		if( !key.includes( `_token` ) ) {
			continue;
		}

		has_token = true;
		break;
	}

	ajax( {
		method: `GET`,
		endpoint: has_token ? `store` : `store?member_uuid=${params.get( `member_uuid` )}`,
		on_success: response => {
			createMainStore( response );
			create_router( response );
			init( response );
		},
		on_error: response => {
			notify( `error`, response );
		}
	} );
} )();
